import script from "./reservationSuccess.vue?vue&type=script&setup=true&lang=js"
export * from "./reservationSuccess.vue?vue&type=script&setup=true&lang=js"

import "./reservationSuccess.vue?vue&type=style&index=0&id=f815bbde&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/web-h5-hade/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f815bbde"]])

export default __exports__